import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The tenant's technicians, for the technician selects.
 *
 * Backed by the shared lookup in userStore rather than useUsers: that one drives the paged admin
 * list and clears itself on unmount, so a select living inside a panel refetched the same handful
 * of names every time the panel was reopened. Consumers must be mobx observers to see the load.
 */
export const useTechnicians = () => {
  const { userStore } = useStore();

  useEffect(() => {
    userStore.loadTechnicians();
  }, [userStore]);

  return {
    loading: !userStore.techniciansLoaded,
    technicians: userStore.technicians,
    refresh: () => userStore.loadTechnicians(true),
  };
};
